import {Component, Input} from '@angular/core';
import {Document} from '../../../types/document-data.types';
import {DocumentsService} from '../../../services/documents.service';
import {DateTransformer} from '../../../services/date-transformer.service';
import { AuthenticationService } from '../../../services/authentication.service';

declare const swal: any;

@Component({
    selector: '[document-item]',
    templateUrl: './document-item.component.html',
    styleUrls: ['./document-item.component.scss']
})
export class DocumentItemComponent {
    @Input() data: Document;

    constructor(public ds: DocumentsService,
                public authenticationService: AuthenticationService
    ) { }

    public transformDate(date: Date): string {

        return DateTransformer.transformDate(date);
    }

    public transformSize(bytes) {
        if (bytes) {
            const thresh = 1024;
            if (Math.abs(bytes) < thresh) {
                return bytes + ' B';
            }

            const units = ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

            let u = -1;
            do {
                bytes /= thresh;
                ++u;
            } while (Math.abs(bytes) >= thresh && u < units.length - 1);

            return bytes.toFixed(1) + ' ' + units[u];
        }
    }

    public onClick(event): void {
        switch (event.action) {
            case 'show': {
                this.showDocument(event.data);
                break;
            }
            case 'remove': {
                this.remove(event.data);
                break;
            }
            case 'edit-permissions': {
                this.ds.showEditPermissionModal(event.data);
                break;
            }
            case 'move': {
                this.ds.showMoveModal(event.data);
                break;
            }
            default: {
                break;
            }
        }
    }

    public remove(document: Document): void {
        swal({
                title: 'Delete ' + document.name,
                text: 'Are you sure you want to delete?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                closeOnConfirm: true
            }, () => {
                this.ds.remove(document);
            }
        );
    }

    public showDocument(document: Document, event?): void {
        if(event)
            event.stopPropagation();
        document = new Document(document);
        if(this.authenticationService.userIsResident) {
            if (document.isImage) {
                this.ds.showImage(document);
            } else if (document.idDirectory) {
                this.ds.goTo(document.id);
            } else {
                document.show();
            }
        } else {
            if (document.idDirectory)
                this.ds.goTo(document.id);
        }
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/documents/document-item/document-item.component.ts